"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var document_service_1 = require("../../document.service");
var http_1 = require("@angular/common/http");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var ErrorObservable_1 = require("rxjs/observable/ErrorObservable");
var Upload = /** @class */ (function () {
    function Upload(documentService, messageService) {
        this.documentService = documentService;
        this.messageService = messageService;
        /** Allow you to add handler after its completion. Bubble up response text from remote. */
        this.fileUploadAction = new core_1.EventEmitter();
        this._validationMessage = "";
    }
    Upload_1 = Upload;
    Object.defineProperty(Upload.prototype, "fileValidationMessage", {
        get: function () {
            return this._fileValidationMessage;
        },
        set: function (fileValidationMessage) {
            this._fileValidationMessage = fileValidationMessage;
            this._validationMessage = this._validationMessage ? this._fileValidationMessage : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Upload.prototype, "uploadedFile", {
        get: function () {
            return this._uploadedFile;
        },
        set: function (value) {
            this._uploadedFile = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Upload.prototype, "validationMessage", {
        get: function () {
            return this._validationMessage;
        },
        set: function (value) {
            this._validationMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Upload.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._fileUpload = document.getElementById("" + this.id + Upload_1.INPUT_ID);
        this._fileUpload.onchange = function () {
            _this._uploadedFile = _this._fileUpload.files[0];
        };
    };
    Upload.prototype.onClick = function () {
        this._fileUpload.click();
        this._validationMessage = "";
    };
    // TODO refactor
    Upload.prototype.uploadFile = function () {
        var _this = this;
        this.validate().subscribe(function () { return _this.fileUploadAction.emit({ file: _this._uploadedFile }); }, function (error) {
            if (error instanceof http_1.HttpErrorResponse) {
                if (error.status == 400) {
                    if (error.error.hasOwnProperty("type") && error.error.type === "EXTENSION") {
                        _this.messageService
                            .getMessageWithPlaceholder("document.service.errors.extension", [
                            error.error.currentExtension,
                        ])
                            .subscribe(function (message) { return (_this.validationMessage = message); });
                    }
                    else if (error.error.hasOwnProperty("type") && error.error.type === "SIZE") {
                        _this.messageService
                            .getMessageWithPlaceholder("document.service.errors.size", [error.error.currentSize])
                            .subscribe(function (message) { return (_this.validationMessage = message); });
                    }
                }
                else {
                    _this.validationMessage = error.message;
                }
            }
            else {
                _this.validationMessage = error;
            }
        });
    };
    Upload.prototype.validate = function () {
        if (!this._uploadedFile) {
            return new ErrorObservable_1.ErrorObservable(Upload_1.FILE_VALIDATION_DEFAULT_MESSAGE);
        }
        if (this.maxSize && this._uploadedFile.size > this.maxSize * Upload_1.MB_IN_BYTES) {
            return new ErrorObservable_1.ErrorObservable(Upload_1.SIZE_VALIDATION_DEFAULT_MESSAGE);
        }
        return this.documentService.validate(this._uploadedFile);
    };
    Upload.prototype.cancelFile = function () {
        this._uploadedFile = null;
        this._fileUpload.value = "";
    };
    Upload.MB_IN_BYTES = 1048576;
    Upload.FILE_VALIDATION_DEFAULT_MESSAGE = "Please select the file.";
    Upload.SIZE_VALIDATION_DEFAULT_MESSAGE = "File is too large.";
    Upload.INPUT_ID = "-file";
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], Upload.prototype, "maxSize", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Upload.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], Upload.prototype, "fileValidationMessage", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], Upload.prototype, "sizeValidationMessage", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], Upload.prototype, "fileUploadAction", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], Upload.prototype, "validationMessage", null);
    Upload = Upload_1 = __decorate([
        core_1.Component({
            
            selector: "sis-upload",
            styles: [require('./sis-upload.component.css')],
            template: require('./sis-upload.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            groups: [
                {
                    identity: "Controls",
                    name: "Controls",
                },
            ],
            template: "<sis-upload class=\"sis-upload\"   [id]=\"'%{id}'\" [maxSize]=\"'%{maxSize}'\"\n                                                        (fileUploadAction)=\"%{fileUploadAction}\" >\n                       </sis-upload>",
            iconInfo: "fa-caret-square-o-down",
            name: "Upload",
        }),
        __metadata("design:paramtypes", [document_service_1.DocumentService, idm_message_language_service_client_js_1.MessageService])
    ], Upload);
    return Upload;
    var Upload_1;
}());
exports.Upload = Upload;
//# sourceMappingURL=sis-upload.component.js.map